(ns io.daskul.tutorial.webapp.hooks.feature-flags
  "React hooks for feature flags."
  (:require
   [uix.re-frame :as urf]
   [io.daskul.tutorial.webapp.domain.feature-flags.subs :as ff.subs]))

(defn use-feature-flag
  "Hook to check if a feature flag is enabled.

   Usage:
     (let [dark-mode? (use-feature-flag \"dark-mode\")]
       (when dark-mode?
         ($ dark-mode-toggle)))

   Returns boolean - true if flag exists and is enabled for current user."
  [flag-name]
  (urf/use-subscribe [::ff.subs/enabled? flag-name]))
